import * as React from 'react';
import {FC} from 'react';
import classNames from 'classnames';
import Tooltip  from 'rc-tooltip';
import './Chat.sass';
import {Avatar, TAvatarType} from '../Avatar/Avatar';
import {Icon} from '@iconify/react';


export interface IChatProps {
    avatar_url: string;
    avatar_type: TAvatarType;
    top_icon: string;
    bottom_icon: string;
    name: string;
    name_suffix: string;
    online: boolean;
    status_text: string;
    selected: boolean;
    notification: number;
    buddy?: boolean;

    onCopyIconClick: () => void;
    onStatusTextClick: () => void;
}


export const Chat: FC<Partial<IChatProps>> = ({
    avatar_url = '',
    avatar_type = 'user',
    name = 'Guest',
    name_suffix = '',
    online,
    status_text = 'offline',
    selected = false,
    notification,
    buddy,

    onCopyIconClick,
    onStatusTextClick,

}) => {
    const [showTooltip, setShowTooltip] = React.useState(false);
    const handleCopyClick = (evt: React.MouseEvent) => {
        evt.stopPropagation();
        onCopyIconClick && onCopyIconClick();
        setShowTooltip(true);
        window.setTimeout(() => setShowTooltip(false), 2000)
    }
    return (
        <div className={classNames('chat', {selected})}>

            <Avatar uri={avatar_url} online={online} type={avatar_type}/>
            <div className={'chat-info'}>
                <span className={'chat-name'}>
                    {name}
                    {name_suffix && <span className={'chat-name-id'}>#{name_suffix}</span>}
                    {buddy && <Icon className={'chat-name-icon'} icon={'majesticons:user'} height={15}/>}
                </span>

                <span className={'chat-status'}>
                    <span onClick={onStatusTextClick}
                          className={classNames('chat-status-text', {clickable: !!onStatusTextClick})}>
                        {status_text}
                        {/*{onStatusTextClick && <Icon*/}
                        {/*  onClick={onStatusTextClick}*/}
                        {/*  className={'chat-status-arrow-icon'}*/}
                        {/*  icon={'bi:arrow-up-right'} height={11}/>}*/}
                    </span>
                    {onCopyIconClick && (
                        <Tooltip placement="top" overlay="Copied" visible={showTooltip} overlayClassName="tooltip-overlay">
                            <Icon
                                onClick={handleCopyClick}
                                className={'chat-copy-icon'}
                                icon={'fluent:copy-20-regular'}
                                height={15}
                            />
                        </Tooltip>
                    )}
                </span>
            </div>
            {notification && <span className={'mvc-chat-notification'}>{notification}</span>}
        </div>
    );
};






